'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FloatingWhatsAppButtonProps {
  activeSection?: string;
}

const FloatingWhatsAppButton = ({ activeSection = 'inicio' }: FloatingWhatsAppButtonProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    // ✅ NÚMERO ACTUALIZADO
    const phoneNumber = '5493876856439';
    
    // ✅ MENSAJE ÚNICO ESTANDARIZADO
    const message = encodeURIComponent(
      'Hola, estoy interesado en conocer más sobre el sistema de preparación física de Victor Cuellar.'
    );
    
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');

    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'whatsapp_click', {
        location: 'floating_button',
        section: activeSection,
        message_type: 'standard_inquiry', // Etiqueta para seguimiento
      });
    }
  };

  if (!isVisible) return null;

  return (
    <button data-component-id="src/components/common/FloatingWhatsAppButton.tsx:48:4" data-component-path="src/components/common/FloatingWhatsAppButton.tsx" data-component-line="48" data-component-end-line="73" data-component-file="FloatingWhatsAppButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22fixed%20bottom-6%20right-6%20z-%5B150%5D%20group%22%7D"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="fixed bottom-6 right-6 z-[150] group"
      aria-label="Contactar por WhatsApp"
    >
      <div data-component-id="src/components/common/FloatingWhatsAppButton.tsx:55:6" data-component-path="src/components/common/FloatingWhatsAppButton.tsx" data-component-line="55" data-component-end-line="71" data-component-file="FloatingWhatsAppButton.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
        className={`flex items-center space-x-3 px-5 py-4 bg-primary hover:bg-primary/90 text-white rounded-full shadow-cta transition-all duration-250 ${
          isHovered ? 'pr-6' : ''
        }`}
      >
        <div data-component-id="src/components/common/FloatingWhatsAppButton.tsx:60:8" data-component-path="src/components/common/FloatingWhatsAppButton.tsx" data-component-line="60" data-component-end-line="63" data-component-file="FloatingWhatsAppButton.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%22%7D" className="relative">
          <Icon data-component-id="src/components/common/FloatingWhatsAppButton.tsx:61:10" data-component-path="src/components/common/FloatingWhatsAppButton.tsx" data-component-line="61" data-component-end-line="61" data-component-file="FloatingWhatsAppButton.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ChatBubbleLeftRightIcon%22%7D" name="ChatBubbleLeftRightIcon" size={24} variant="solid" />
          <span data-component-id="src/components/common/FloatingWhatsAppButton.tsx:62:10" data-component-path="src/components/common/FloatingWhatsAppButton.tsx" data-component-line="62" data-component-end-line="62" data-component-file="FloatingWhatsAppButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20-top-1%20-right-1%20w-3%20h-3%20bg-success%20rounded-full%20animate-pulse-glow%22%7D" className="absolute -top-1 -right-1 w-3 h-3 bg-success rounded-full animate-pulse-glow"></span>
        </div>
        <span data-component-id="src/components/common/FloatingWhatsAppButton.tsx:64:8" data-component-path="src/components/common/FloatingWhatsAppButton.tsx" data-component-line="64" data-component-end-line="70" data-component-file="FloatingWhatsAppButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22Consulta%20Ahora%22%7D"
          className={`font-cta font-bold text-sm whitespace-nowrap overflow-hidden transition-all duration-250 ${
            isHovered ? 'max-w-[200px] opacity-100' : 'max-w-0 opacity-0'
          }`}
        >
          Consulta Ahora
        </span>
      </div>
      <div data-component-id="src/components/common/FloatingWhatsAppButton.tsx:72:6" data-component-path="src/components/common/FloatingWhatsAppButton.tsx" data-component-line="72" data-component-end-line="72" data-component-file="FloatingWhatsAppButton.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20inset-0%20bg-primary%20rounded-full%20animate-pulse-glow%20opacity-50%20-z-10%22%7D" className="absolute inset-0 bg-primary rounded-full animate-pulse-glow opacity-50 -z-10"></div>
    </button>
  );
};

export default FloatingWhatsAppButton;